import { render, staticRenderFns } from "./ObiPortalProviderMethod.vue?vue&type=template&id=ceac192e&scoped=true&"
import script from "./ObiPortalProviderMethod.vue?vue&type=script&lang=js&"
export * from "./ObiPortalProviderMethod.vue?vue&type=script&lang=js&"
import style0 from "./ObiPortalProviderMethod.vue?vue&type=style&index=0&id=ceac192e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceac192e",
  null
  
)

export default component.exports